<template>
<div class="user">
    <h1 class="subheading grey--text">Min side</h1>

    <v-tabs slot="extension" v-model="tabs" fixed-tabs color="transparent" icons-and-text>
        <v-tabs-slider></v-tabs-slider>
        <v-tab to="/user" href="#1" class="grey--text">
            Profil
            <v-icon>person</v-icon>
        </v-tab>

        <v-tab to="/userbookings" href="#2" class="grey--text">
            Mine reservationer
            <v-icon>dashboard</v-icon>
        </v-tab>

        <v-tab to="/userhorses" href="#3" class="grey--text">
            Mine heste
            <v-icon>favorite</v-icon>
        </v-tab>
    </v-tabs>

    <v-container class="my-1">
        <v-flex xs12 mt-4>
            <div class="grey--text">Mine heste</div>
        </v-flex>
        <v-divider></v-divider>
        <v-layout column>
            <v-card v-for="horse in horses.filter(horse => { return horse.userid === profile.id})" :key="horse.id">
                <v-layout class="pa-2" row align-content-space-between>

                    <v-flex xs6 sm9 md10>
                        <div class="caption grey--text">Hest</div>
                        <div>{{horse.name}}</div>
                    </v-flex>
                    <v-flex xs6 sm3 md2>
                        <v-chip color="red" text-color="white" @click="deleteHorse(horse.id)">
                            Slet
                            <v-icon right>delete</v-icon>
                        </v-chip>
                    </v-flex>

                </v-layout>
                <v-divider></v-divider>

            </v-card>
            <v-divider></v-divider>
            <v-flex xs12 sm6 md4 mt-4>
                <v-form class="px-3" ref="form">
                    <v-text-field label="Navn (Ny hest)" v-model="newHorseName"></v-text-field>
                    <v-alert v-model="$store.state.showAlertAddHorse" color="error">
                        {{$store.state.message}}
                    </v-alert>
                    <v-spacer></v-spacer>
                    <v-btn flat class="success mx-0 mt-3" @click="addNewHorse" :loading="loading">Tilføj ny hest</v-btn>
                </v-form>
            </v-flex>
        </v-layout>

    </v-container>
</div>
</template>

<script>
import format from 'date-fns/format'

export default {

    data() {
        return {
            doneSave: false,
            tabs: '3',
            newHorseName: '',
            secretKeyInput: '',
            newName: '',
            newEmail: '',
            message: '',
            showAlert: false,
            loading: false,
            name: '',
            horseid: '',
            emailRules: [
                v => !!v || "E-mail skal udfyldes",
                v =>
                /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                "E-mail skal være korrekt"
            ],
            passwordRules: [v => !!v || "Password skal udfyldes"],
            nameRules: [
                v => v.length >= 2 || 'Navn skal være mindst 2 tegn',
            ],
        }
    },
    computed: {
        userApproved() {
            if (this.$store.getters.profile.approved)
                return false
            else
                return true
        },
        db() {
            return this.$store.state.db
        },
        users() {
            return this.$store.getters.users
        },
        userid() {
            //console.log('#user compute userid')
            return this.$store.state.authUser.uid
        },
        email() {
            return this.$store.getters.profile.email
        },
        profile() {
            return this.$store.getters.profile
        },
        user() {
            //console.log('#user compute user')
            return this.userById(this.users, this.userid)
        },
        horses() {
            return this.$store.getters.horses
        },
        resources() {
            return this.$store.getters.resources
        },
        bookings() {
            return this.$store.getters.bookings
        },
        noBookings() {
            return this.bookings.filter(booking => {
                return booking.userid === this.profile.id
            }).length
        }
    },
    created: function () {
        this.newName = this.$store.getters.profile.name
        this.newEmail = this.$store.getters.profile.email

        //this.$store.dispatch('setProfile', { vm: this })
        this.currentDate = format(Date.now(), 'YYYY-MM-DD')

    },
    methods: {
        addNewHorse() {
            this.$store.dispatch('addNewHorse', {
                newHorseName: this.newHorseName.trim(),
                profile: this.profile,
                vm: this
            }).then(() => {
                this.newHorseName = ''
            })
        },
        deleteHorse(horseid) {
            this.$store.dispatch('deleteHorse', {
                horseid: horseid,
                profile: this.profile,
                vm: this
            })
        },
        deleteBooking(bookingid) {
            const db = this.$firebase.firestore()
            //('delete:' + bookingid)
            db.collection('bookings').doc(bookingid).delete().then(() => {

                    const index = this.bookings.findIndex(function (booking) {
                        return booking.id === bookingid
                    })
                    if (index > -1) {
                        //console.log('index:' , index)
                        this.bookings.splice(index, 1)
                    }
                })
                .catch(err => {
                    console.log(err.message)
                });
        },
        submit() {

            const db = this.$firebase.firestore()
            //let codeOK = false
            if (this.$refs.form.validate()) {
                this.$store.dispatch('setShowAlert', false)
                this.$store.dispatch('setMessage', '')
                this.loading = true;
                this.doneSave = false

                if (!this.$store.getters.profile.approved && this.secretKeyInput !== '') {

                    if (this.$store.getters.config.secretKey.localeCompare(this.secretKeyInput) === 0) {
                        //codeOK = true
                        this.$store.getters.profile.approved = true
                        //console.log('code ok')
                        this.doneSave = false
                    } else {
                        //console.log('code not ok')
                        this.$store.dispatch('setShowAlert', true)
                        this.$store.dispatch('setMessage', 'Koden er ikke korrekt')

                        this.doneSave = true
                        this.loading = false;
                    }
                }

                if (this.$store.getters.profile.email !== this.newEmail) {
                    var user = this.$firebase.auth().currentUser;

                    user.updateEmail(this.newEmail).then(function () {
                            // Update successful.
                        })
                        .catch(err => {
                            this.$store.state.message = err.message
                            this.$store.state.showAlert = true
                        });

                }

                if (!this.doneSave) {
                    db.collection('users').doc(this.$store.getters.profile.id).set({
                        name: this.newName.trim(),
                        user_id: this.$store.getters.profile.user_id,
                        approved: this.$store.getters.profile.approved,
                        admin: this.$store.getters.profile.admin,
                        created: this.$store.getters.profile.created,
                        active: this.$store.getters.profile.active
                    }).then(() => {
                        this.$store.getters.profile.name = this.newName
                        this.loading = false;
                        this.$store.state.showAlert = false;
                        this.$store.state.message = '';
                        this.$emit('nameUpdated');
                    })
                }
            }
        },
        resourceName(resources, resid) {
            let resource = []
            resource = this.resourceById(resources, resid)
            if (typeof resource !== 'undefined') {
                return resource.name
            } else {
                return ''
            }
        },
        resourceById(resources, residToFind) {
            const resource = resources.find(function (resource) {
                return resource.id === residToFind;
            })
            return resource
        },
        horseName(horses, horseid) {
            let horse = []
            horse = this.horseById(horses, horseid)
            if (typeof horse !== 'undefined') {
                return horse.name
            } else {
                return 'Ukendt'
            }
        },
        horseById(horses, horseidToFind) {
            const horse = horses.find(function (horse) {
                return horse.id === horseidToFind;
            })
            return horse
        },
        userName(users, userid) {

            let user = []
            user = this.userById(users, userid)
            if (typeof user !== 'undefined') {
                return user.name
            } else {
                return ''
            }
        },
        userById(users, useridToFind) {
            const user = users.find(function (user) {
                return user.id === useridToFind;
            })
            return user
        },
        sortBy(prop) {
            this.bookings.sort((a, b) => a[prop] < b[prop] ? -1 : 1)
        }
    },

}
</script>
